import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getGameTypeList } from '../../services'
import { GetGameTypeResponse } from '@/modules/game/type'
import { GameQueryKeys } from '@/modules/game/keys'

export default function useQueryGetGameTypeList(
	props?: UseBaseQueryOptions<GetGameTypeResponse>,
) {
	return useQuery({
		queryKey: [GameQueryKeys.GetGameTypeList],
		queryFn: () => getGameTypeList(),
		...props,
	})
}
